'use es6';

import http from 'hub-http/clients/apiClient';
import { DEFAULT_PAGINATION_LIMIT } from 'DesignData/settings/api';
export function searchAssetsEs(searchTerm, offset) {
  return http.get('designmanagersearch/v1/search/paginated', {
    query: {
      searchTerm,
      limit: DEFAULT_PAGINATION_LIMIT,
      offset
    }
  });
}
export function fetchRecentlyDeleted() {
  return http.get('designmanager/v1/assets/recent/deleted');
}
export function fetchRecentlyEdited() {
  return http.get('designmanager/v1/assets/recent');
}